var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('Header'),_c('main',{staticClass:"main"},[_c('SideBar'),_c('div',{staticClass:"content"},[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }